export default __webpack_public_path__ + "static/id_01-4876c010bf3efe6f9ace6564706123c2.png";